import React, { useState, useEffect } from "react";
import { useCart } from "./cartcontext";
import { useLocation } from "react-router-dom";
import "./Products.css";
  import { getCachedData } from './cacheService'; 

function Products() {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [activeFilter, setActiveFilter] = useState("All");
  const [notification, setNotification] = useState("");
  const { addtoCart } = useCart();
  const location = useLocation();

  useEffect(() => {
  getCachedData().then(data => {
    if (data.products) {
      setProducts(data.products);
      setFilteredProducts(data.products);
    }
  });
}, []);
  // Fetch products from db.json
  useEffect(() => {
    fetch("/Data/db.json")
      .then((res) => res.json())
      .then((data) => {
        if (data.products) {
          setProducts(data.products);
          setFilteredProducts(data.products);
        }
      })
      .catch((error) => console.error("Error fetching products:", error));
  }, []);

  // Apply query param filter if present
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const filterParam = params.get("filter");
    if (filterParam && products.length) {
      const results = products.filter(
        (p) => p.categoryName.toLowerCase() === filterParam.toLowerCase()
      );
      setFilteredProducts(results);
      setActiveFilter(filterParam);
    }
  }, [location.search, products]);

  // Search handler
  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);

    let results = products.filter((p) =>
      p.name.toLowerCase().includes(value)
    );

    if (activeFilter !== "All") {
      results = results.filter(
        (p) => p.categoryName.toLowerCase() === activeFilter.toLowerCase()
      );
    }

    setFilteredProducts(results);
  };

  // Filter buttons handler
  const handleFilter = (type) => {
    setActiveFilter(type);

    let results = products;
    if (type !== "All") {
      results = products.filter(
        (p) => p.categoryName.toLowerCase() === type.toLowerCase()
      );
    }

    if (searchTerm) {
      results = results.filter((p) =>
        p.name.toLowerCase().includes(searchTerm)
      );
    }

    setFilteredProducts(results);
  };

  // Add to cart with notification
  const handleAddToCart = (product) => {
    addtoCart(product);
    setNotification(`${product.name} added to quote!`);
    setTimeout(() => setNotification(""), 3000);
  };

  return (
    <div className="products">
      <div className="pheader">
        <h2>Our Products</h2>
        <p>
          Discover our comprehensive range of premium aluminum doors, windows,
          and architectural solutions, crafted with precision and designed to
          last.
        </p>
      </div>

      {/* Notification */}
      {notification && <div className="notification">{notification}</div>}

      {/* Search and Filters */}
      <div className="search">
        <input
          type="text"
          placeholder="Search products..."
          value={searchTerm}
          onChange={handleSearch}
        />
        <span className="material-symbols-outlined">filter_alt</span>
        <div className="filter-buttons">
          {["All", "Doors", "Windows", "Sliding", "Garage"].map((cat) => (
            <button
              key={cat}
              className={activeFilter === cat ? "active" : ""}
              onClick={() => handleFilter(cat)}
            >
              {cat}
            </button>
          ))}
        </div>
      </div>

      {/* Product Grid */}
      <div className="product-grid">
        {filteredProducts.map((product) => (
          <div className="product-card" key={product.id}>
            <div className="product-image-container">
              <img src={product.mainImageUrl} alt={product.name} />
              <div className="category-label">{product.categoryName}</div>
              <div className="rating">
                <i className="fas fa-star"></i> {product.rating}
              </div>
            </div>
            <div className="product-content">
              <h3>{product.name}</h3>
              <p className="description">{product.description}</p>
              <div className="price-info">
                <span className="price">{product.priceRange}</span>
              </div>
              {/* Key Features */}
              <div className="key-features">
                <h5>Key Features:</h5>
                <ul>
                  {product.keyFeatures &&
                    product.keyFeatures.map((feature, index) => (
                      <li key={index}>{feature}</li>
                    ))}
                </ul>
              </div>
            </div>
            <div className="card-buttons">
              <button
                className="add-quote-btn"
                onClick={() => handleAddToCart(product)}
              >
                Add to Quote
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Products;